<div class="component-main">
    <div class="content-space-between">
        <div class="content-left">
            <h1 id="component-title">{{ 'organizations' |myLbTranslate }}</h1>
        </div>
    </div>
    <div class="content page-wrapper">
        <p>organisations works!</p>
    </div>
</div>
